import React, { lazy } from "react";
import ProtectedRoute from "../components/auth/ProtectedRoute";

// On garde Home en import classique car c'est la page d'entrée (LCP)
import Home from "../pages/Home";

// On utilise lazy pour TOUT le reste
const JobOffersList = lazy(() => import("../pages/JobOffers/List"));
const Login = lazy(() => import("../pages/Login"));
const Register = lazy(() => import("../pages/Register"));
const ForgotPassword = lazy(() => import("../pages/ForgotPassword"));
const Dashboard = lazy(() => import("../pages/Candidate/Dashboard"));
const JobOfferDetails = lazy(() => import("../pages/JobOffers/Details"));
const Profile = lazy(() => import("../pages/Candidate/Profile"));
const VerifyEmail = lazy(() => import("../pages/Auth/VerifyEmail"));
const NotFound = lazy(() => import("../pages/NotFound"));
const SettingsPage = lazy(() => import("../pages/Candidate/Settings"));
const CompaniesList = lazy(() => import("../pages/Companies/List"));
const MissionsList = lazy(() => import("../pages/Missions/List"));
const MissionDetails = lazy(() => import("../pages/Missions/Details"));
const Applications = lazy(() => import("../pages/Candidate/MyApplications"));
const CompanyDetails = lazy(() => import("../pages/Companies/Details"));
const CVForm = lazy(() => import("../pages/CVGenerator"));
const AboutUs = lazy(() => import("../pages/AboutUs"));
const CandidateMessaging = lazy(() => import("../pages/Candidate/Messages"));
const Privacy = lazy(() => import("../pages/Privacy"));
const Terms = lazy(() => import("../pages/Terms"));
const ContactAdmin = lazy(() => import("../pages/Contact/ContactAdmin"));

const routes = [
  // Public routes
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/job-offers",
    element: <JobOffersList />,
  },
  {
    path: "/job-offers/:id",
    element: <JobOfferDetails />,
  },
  {
    path: "/missions",
    element: <MissionsList />,
  },
  {
    path: "/missions/:id",
    element: <MissionDetails />,
  },
  {
    path: "/companies",
    element: <CompaniesList />,
  },
  {
    path: "/company/:id",
    element: <CompanyDetails />,
  },
  {
    path: "/about",
    element: <AboutUs />
  },
  {
    path: "/verify-email",
    element: <VerifyEmail />,
  },
  { path: "/cv-generator", element: <CVForm /> },

  // Protected routes - these require authentication
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute allowedRoles={["candidate"]}>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/messages",
    element: (
      <ProtectedRoute allowedRoles={["candidate"]}>
        <CandidateMessaging />
      </ProtectedRoute>
    ),
  },
  {
    path: "/applications",
    element: (
      <ProtectedRoute allowedRoles={["candidate"]}>
        <Applications />
      </ProtectedRoute>
    ),
  },

  {
    path: "/profile",
    element: (
      <ProtectedRoute allowedRoles={["candidate"]}>
        <Profile />
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings",
    element: (
      <ProtectedRoute allowedRoles={["candidate"]}>
        <SettingsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/contact",
    element: <ContactAdmin />,
  },


  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
